import React, { Component } from "react";
import { API } from "aws-amplify";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import  Moment  from 'moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';
import ResetIcon from '@material-ui/icons/LockOpen';

export default class UserAdminList extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isLoading: true,
      users: []
    };

  }

  async componentDidMount() {
    
    if (!this.props.isAuthenticated) {
      return;
    }

    try {
      var result = await this.registeredUsers();
      var rows = result.users;
      this.setState({ users: rows });
    } catch (e) {
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  registeredUsers() {
    return API.get("license", "/list-users");
  }

  createData(UserId) {
    return { UserId };
  }

  unregisterUser(row) {
    this.props.history.push('/admin/unregister', {
      UserId: row.UserId,
      Email: row.UserEmail,
    });
  }

  resetUserPassword(row) {
    this.props.history.push('/admin/password/reset', {
      UserId: row.UserId,
      Email: row.UserEmail,
    });
  }

  renderRegisteredUsers(rows) {
    const StyledTable  = makeStyles(theme => ({
      root: {
        width: '100%',
      },
      paper: {
        marginTop: theme.spacing(3),
        width: '100%',
        overflowX: 'auto',
        marginBottom: theme.spacing(2),
      },
      table: {
        minWidth: 650,
      },
    }));
    const StyledTableRow = withStyles(theme => ({
      root: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.background.default,
        },
      },
    }))(TableRow);
    const StyledTableCell = withStyles(theme => ({
      head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
      },
      body: {
        fontSize: 14,
      },
    }))(TableCell);

    return (
      <Paper className={StyledTable.root}>
          <Table className={StyledTable.table} size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell width="300">Date Created</StyledTableCell>
              <StyledTableCell width="300">Last Accessed</StyledTableCell>
              <StyledTableCell width="300">Last Version</StyledTableCell>
              <StyledTableCell width="50">Password</StyledTableCell>
              <StyledTableCell width="50">Delete</StyledTableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {rows.map(row => (
            <StyledTableRow  key={row.UserEmail}>
              <StyledTableCell  component="th" scope="row">
                {row.UserEmail}
              </StyledTableCell >
              <StyledTableCell  align="left">{Moment(row.UserCreated).format('MMMM Do YYYY')}</StyledTableCell >
              <StyledTableCell  align="left">{Moment(row.LastAccessed).format('MMMM Do YYYY')}</StyledTableCell >
              <StyledTableCell  align="left">{row.LastVersion}</StyledTableCell >
              <StyledTableCell  align="left"><div><IconButton onClick={() => this.resetUserPassword(row)}  size="small" aria-label="reset"><ResetIcon /></IconButton></div></StyledTableCell >
              <StyledTableCell  align="left"><div><IconButton onClick={() => this.unregisterUser(row)}  size="small" aria-label="delete"><DeleteIcon /></IconButton></div></StyledTableCell >
            </StyledTableRow >
            ))}
        </TableBody>      
        </Table>
      </Paper>
    );
  }

  render() {
    return (
      <div className="main">
        <h1>DataStar Licensed Users</h1>
        <p></p>
        <div>
          {!this.state.isLoading && this.renderRegisteredUsers(this.state.users)}
        </div>
      </div>
    );
  }

}